import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const safety_assessment_questions:SchemaTableOptions = {
    name:<string> 'safety_assessment_questions',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'description', value: 'VARCHAR(255) NOT NULL'},
    ]
}